var map = {
	"./Close_Teasure.png": 9289,
	"./Golden_Ticket.png": 6318,
	"./Open_Teasure.png": 5981,
	"./Silver_Ticket.png": 4453,
	"./approve.png": 5403,
	"./avatars/avatar-agent-01.png": 9703,
	"./avatars/avatar-king-01.png": 1984,
	"./avatars/avatar-king-02.png": 2609,
	"./avatars/avatar-leader-01.png": 8993,
	"./avatars/avatar-partner-01.png": 2765,
	"./avatars/manager/01.png": 8659,
	"./avatars/manager/02.png": 8061,
	"./avatars/manager/03.png": 9578,
	"./avatars/manager/04.png": 6539,
	"./avatars/manager/07.png": 1690,
	"./avatars/manager/08.png": 723,
	"./avatars/manager/09.png": 5971,
	"./avatars/manager/10.png": 4760,
	"./avatars/owner/01.png": 7806,
	"./avatars/owner/02.png": 6759,
	"./avatars/owner/04.png": 3543,
	"./avatars/owner/05.png": 1426,
	"./avatars/partner/01.png": 8331,
	"./avatars/partner/02.png": 3624,
	"./avatars/staff/01.png": 2104,
	"./avatars/staff/02.png": 9896,
	"./avatars/staff/03.png": 2149,
	"./avatars/staff/04.png": 4841,
	"./avatars/staff/05.png": 4025,
	"./avatars/staff/06.png": 6870,
	"./avatars/staff/07.png": 4333,
	"./avatars/staff/08.png": 7469,
	"./avatars/staff/09.png": 2127,
	"./avatars/staff/10.png": 9764,
	"./avatars/staff/11.png": 2396,
	"./avatars/staff/12.png": 4178,
	"./avatars/staff/13.png": 258,
	"./avatars/staff/14.png": 3485,
	"./avatars/staff/15.png": 6219,
	"./avatars/staff/16.png": 8015,
	"./avatars/staff/17.png": 6417,
	"./avatars/staff/18.png": 9242,
	"./avatars/staff/19.png": 8288,
	"./avatars/staff/20.png": 366,
	"./avatars/staff/21.png": 2971,
	"./avatars/staff/22.png": 849,
	"./avatars/staff/23.png": 6651,
	"./avatars/staff/24.png": 476,
	"./avatars/staff/25.png": 6938,
	"./avatars/staff/26.png": 7993,
	"./avatars/staff/27.png": 5755,
	"./avatars/staff/28.png": 9742,
	"./avatars/staff/29.png": 9113,
	"./avatars/staff/30.png": 9552,
	"./avatars/staff/31.png": 2530,
	"./avatars/staff/32.png": 3399,
	"./avatars/staff/33.png": 3244,
	"./avatars/staff/34.png": 9438,
	"./avatars/staff/35.png": 7735,
	"./avatars/staff/36.png": 9619,
	"./avatars/system/01.png": 7074,
	"./avatars/system/02.png": 3998,
	"./banking/smooth-corner.png": 6046,
	"./banking/square.png": 7901,
	"./banking/th/smooth-corner/baac.png": 9594,
	"./banking/th/smooth-corner/bay.png": 4673,
	"./banking/th/smooth-corner/bbl.png": 6802,
	"./banking/th/smooth-corner/bnp.png": 5906,
	"./banking/th/smooth-corner/boa.png": 3979,
	"./banking/th/smooth-corner/cacib.png": 2443,
	"./banking/th/smooth-corner/cimb.png": 481,
	"./banking/th/smooth-corner/citi.png": 8862,
	"./banking/th/smooth-corner/db.png": 123,
	"./banking/th/smooth-corner/ghb.png": 720,
	"./banking/th/smooth-corner/gsb.png": 2297,
	"./banking/th/smooth-corner/hsbc.png": 8454,
	"./banking/th/smooth-corner/ibank.png": 8345,
	"./banking/th/smooth-corner/icbc.png": 4454,
	"./banking/th/smooth-corner/jpm.png": 9876,
	"./banking/th/smooth-corner/kbank.png": 185,
	"./banking/th/smooth-corner/kkp.png": 5417,
	"./banking/th/smooth-corner/ktb.png": 2885,
	"./banking/th/smooth-corner/lhb.png": 4579,
	"./banking/th/smooth-corner/mb.png": 6562,
	"./banking/th/smooth-corner/mega.png": 8779,
	"./banking/th/smooth-corner/mufg.png": 5618,
	"./banking/th/smooth-corner/promptpay.png": 1033,
	"./banking/th/smooth-corner/rbs.png": 224,
	"./banking/th/smooth-corner/sc.png": 8771,
	"./banking/th/smooth-corner/scb.png": 9982,
	"./banking/th/smooth-corner/smbc.png": 1775,
	"./banking/th/smooth-corner/tbank.png": 3737,
	"./banking/th/smooth-corner/tcrb.png": 1078,
	"./banking/th/smooth-corner/tisco.png": 9875,
	"./banking/th/smooth-corner/tmb.png": 1123,
	"./banking/th/smooth-corner/truewallet.png": 1508,
	"./banking/th/smooth-corner/ttb.png": 9747,
	"./banking/th/smooth-corner/uob.png": 6507,
	"./banking/th/square/baac.png": 5725,
	"./banking/th/square/bay.png": 2596,
	"./banking/th/square/bbl.png": 8286,
	"./banking/th/square/bnp.png": 7278,
	"./banking/th/square/boa.png": 3952,
	"./banking/th/square/cacib.png": 5942,
	"./banking/th/square/cimb.png": 5568,
	"./banking/th/square/citi.png": 8467,
	"./banking/th/square/db.png": 3990,
	"./banking/th/square/ghb.png": 549,
	"./banking/th/square/gsb.png": 910,
	"./banking/th/square/hsbc.png": 4113,
	"./banking/th/square/ibank.png": 6140,
	"./banking/th/square/icbc.png": 6619,
	"./banking/th/square/jpm.png": 789,
	"./banking/th/square/kbank.png": 4759,
	"./banking/th/square/kk.png": 37,
	"./banking/th/square/ktb.png": 3308,
	"./banking/th/square/lhb.png": 1573,
	"./banking/th/square/mb.png": 928,
	"./banking/th/square/mega.png": 262,
	"./banking/th/square/mufg.png": 3172,
	"./banking/th/square/promptpay.png": 1552,
	"./banking/th/square/rbs.png": 3087,
	"./banking/th/square/sc.png": 4365,
	"./banking/th/square/scb.png": 5088,
	"./banking/th/square/smbc.png": 8860,
	"./banking/th/square/tbank.png": 6492,
	"./banking/th/square/tcrb.png": 3662,
	"./banking/th/square/tisco.png": 7365,
	"./banking/th/square/tmb.png": 4580,
	"./banking/th/square/ttb.png": 2015,
	"./banking/th/square/uob.png": 4631,
	"./banking/th/white/baac.png": 5522,
	"./banking/th/white/bay.png": 9370,
	"./banking/th/white/bbl.png": 5012,
	"./banking/th/white/bnp.png": 1168,
	"./banking/th/white/boa.png": 2456,
	"./banking/th/white/cacib.png": 9795,
	"./banking/th/white/cimb.png": 1137,
	"./banking/th/white/citi.png": 6503,
	"./banking/th/white/db.png": 9483,
	"./banking/th/white/ghb.png": 912,
	"./banking/th/white/gsb.png": 2542,
	"./banking/th/white/hsbc.png": 4843,
	"./banking/th/white/ibank.png": 1583,
	"./banking/th/white/icbc.png": 2795,
	"./banking/th/white/jpm.png": 6957,
	"./banking/th/white/kbank.png": 4326,
	"./banking/th/white/kk.png": 8025,
	"./banking/th/white/ktb.png": 3600,
	"./banking/th/white/lhb.png": 531,
	"./banking/th/white/mb.png": 9758,
	"./banking/th/white/mega.png": 8737,
	"./banking/th/white/mufg.png": 3349,
	"./banking/th/white/promptpay.png": 2096,
	"./banking/th/white/rbs.png": 5477,
	"./banking/th/white/sc.png": 862,
	"./banking/th/white/scb.png": 5049,
	"./banking/th/white/smbc.png": 7629,
	"./banking/th/white/tbank.png": 9589,
	"./banking/th/white/tcrb.png": 3916,
	"./banking/th/white/tisco.png": 6258,
	"./banking/th/white/tmb.png": 816,
	"./banking/th/white/ttb.png": 6374,
	"./banking/th/white/uob.png": 6845,
	"./banking/white.png": 1989,
	"./banner-baccarat-01.png": 3700,
	"./banner-keno-01.png": 9035,
	"./banner-lotto-01.png": 9652,
	"./banner-poker-01.png": 3830,
	"./banner-slot-01.png": 7407,
	"./banner-sport-01.png": 1530,
	"./bg-002.png": 7745,
	"./cancel.png": 9685,
	"./demo/nav-game-demo1.png": 4919,
	"./demo/nav-game-demo2.png": 9829,
	"./demo/nav-game-demo3.png": 724,
	"./demo/nav-game-demo4.png": 3781,
	"./demo/nav-game-demo5.png": 1895,
	"./demo/nav-game-demo6.png": 9186,
	"./gamescard/content_card_1.png": 1364,
	"./gamescard/content_casino_1.png": 2527,
	"./gamescard/content_fishing_1.png": 1395,
	"./gamescard/content_keno_1.png": 4900,
	"./gamescard/content_slot_1.png": 8425,
	"./gamescard/content_sport_1.png": 3517,
	"./gameshall/ag.png": 7905,
	"./gameshall/ameba.png": 486,
	"./gameshall/dg.png": 9602,
	"./gameshall/ds.png": 1127,
	"./gameshall/gmt.png": 7801,
	"./gameshall/live22.png": 8812,
	"./gameshall/pg.png": 3806,
	"./gameshall/pt.png": 3722,
	"./gameshall/sa.png": 7238,
	"./gameshall/sexy.png": 2630,
	"./gameshall/spg.png": 4902,
	"./gameshall/xo.png": 8627,
	"./home-promotion-01.png": 5859,
	"./home-promotion-02.png": 590,
	"./pending.png": 7014,
	"./social/facebook.png": 6843,
	"./social/instagram.png": 5656,
	"./social/line.png": 2412,
	"./social/telegram.png": 7892,
	"./social/twitter.png": 7243,
	"./social/youtube.png": 6056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;